// Drives the real (hidden) Simple Bundles & Kits selects from 3 simpler
// selects: Model, Culoare husă, Culoare skin. Never recomputes or guesses
// which variant/property to send — it only ever assigns a value that
// already exists as a real <option> in the app's own selects, then fires a
// genuine 'change' event, exactly as if the shopper had used those
// dropdowns directly. If the app's markup isn't found, it does nothing
// rather than risk showing a picker that can't actually drive a cart.
(function(){
  function init(){
    var picker = document.getElementById('bundle-picker');
    var modelSel = document.getElementById('bp-model');
    var huseSel = document.getElementById('bp-husa');
    var skinSel = document.getElementById('bp-skin');
    var msgEl = document.getElementById('bp-msg');
    if (!picker || !modelSel || !huseSel || !skinSel || !msgEl) return;

    // The app injects its own markup client-side, sometimes a beat after
    // page load rather than having it in the initial HTML — so wait for it
    // instead of giving up on the first check.
    var tries = 0;
    (function waitForApp(){
      var appWrap = document.getElementById('simple-bundles-io-options');
      var realSelects = appWrap ? appWrap.querySelectorAll('select') : [];
      if (appWrap && realSelects.length >= 2) {
        start(appWrap, realSelects[0], realSelects[1]);
        return;
      }
      tries++;
      if (tries > 40) { // ~6s at 150ms
        msgEl.hidden = false;
        msgEl.textContent = 'Selectorul nu s-a putut încărca. Reîmprospătează pagina.';
        return;
      }
      setTimeout(waitForApp, 150);
    })();
  }

  function start(appWrap, realHusa, realSkin){
    var modelSel = document.getElementById('bp-model');
    var huseSel = document.getElementById('bp-husa');
    var skinSel = document.getElementById('bp-skin');
    var msgEl = document.getElementById('bp-msg');

    // The app's own UI is still fully present and functional in the DOM —
    // just not shown, since this picker drives it instead.
    appWrap.style.display = 'none';

    var MODELS = ['15', '15 Pro', '15 Pro Max', '16', '16 Pro', '16 Pro Max', '17', '17 Pro', '17 Pro Max'];

    function parseOptions(select){
      var data = {};
      var colors = [];
      Array.prototype.forEach.call(select.options, function(opt){
        if (!opt.value) return;
        var parts = opt.value.split(' / iPhone ');
        if (parts.length !== 2) return;
        var color = parts[0], model = parts[1];
        if (!data[color]) { data[color] = {}; colors.push(color); }
        data[color][model] = {
          value: opt.value,
          inventory: parseInt(opt.getAttribute('data-inventory'), 10) || 0
        };
      });
      return { data: data, colors: colors };
    }

    var husaInfo = parseOptions(realHusa);
    var skinInfo = parseOptions(realSkin);

    function fillSelect(sel, items){
      sel.innerHTML = '';
      items.forEach(function(it){
        var opt = document.createElement('option');
        opt.value = it.value;
        opt.textContent = it.label;
        if (it.disabled) opt.disabled = true;
        sel.appendChild(opt);
      });
    }

    fillSelect(modelSel, [{ value: '', label: 'Alege modelul' }].concat(
      MODELS.map(function(m){ return { value: m, label: 'iPhone ' + m }; })
    ));
    modelSel.disabled = false;

    function refreshColorSelect(sel, info, selectedModel){
      var prevValue = sel.value;
      var items = [{ value: '', label: selectedModel ? 'Alege culoarea' : 'Alege mai întâi modelul' }];
      info.colors.forEach(function(color){
        var entry = selectedModel ? info.data[color][selectedModel] : null;
        var outOfStock = !!selectedModel && (!entry || entry.inventory <= 0);
        items.push({
          value: color,
          label: color + (outOfStock ? ' — Indisponibil' : ''),
          disabled: outOfStock
        });
      });
      fillSelect(sel, items);
      sel.disabled = !selectedModel;
      if (selectedModel && prevValue){
        var stillOk = info.data[prevValue] && info.data[prevValue][selectedModel] && info.data[prevValue][selectedModel].inventory > 0;
        sel.value = stillOk ? prevValue : '';
      }
    }

    function setRealSelect(realSel, value){
      if (realSel.value === value) return;
      realSel.value = value;
      realSel.dispatchEvent(new Event('change', { bubbles: true }));
      realSel.dispatchEvent(new Event('input', { bubbles: true }));
    }

    function findSubmitButton(){
      var form = document.querySelector('form[action="/cart/add"]');
      if (!form) return null;
      return form.querySelector('button[name="add"]') || form.querySelector('button[type="submit"]');
    }

    function evaluate(){
      var model = modelSel.value;
      refreshColorSelect(huseSel, husaInfo, model);
      refreshColorSelect(skinSel, skinInfo, model);

      var huseColor = huseSel.value;
      var skinColor = skinSel.value;
      var huseEntry = (model && huseColor) ? husaInfo.data[huseColor][model] : null;
      var skinEntry = (model && skinColor) ? skinInfo.data[skinColor][model] : null;
      var valid = !!(huseEntry && huseEntry.inventory > 0 && skinEntry && skinEntry.inventory > 0);

      var btn = findSubmitButton();

      if (valid){
        setRealSelect(realHusa, huseEntry.value);
        setRealSelect(realSkin, skinEntry.value);
        msgEl.hidden = true;
        if (btn) btn.disabled = false;
      } else {
        if (btn) btn.disabled = true;
        msgEl.hidden = false;
        msgEl.removeAttribute('data-ok');
        if (!model) msgEl.textContent = 'Alege modelul, culoarea husei și culoarea skin-ului.';
        else if (!huseColor || !skinColor) msgEl.textContent = 'Alege și culoarea husei, și culoarea skin-ului.';
        else msgEl.textContent = 'Combinația aleasă nu mai e în stoc pentru acest model. Alege altă culoare.';
      }
    }

    modelSel.addEventListener('change', evaluate);
    huseSel.addEventListener('change', evaluate);
    skinSel.addEventListener('change', evaluate);

    var initialBtn = findSubmitButton();
    if (initialBtn) initialBtn.disabled = true;

    evaluate();
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
